import React from 'react';
import Image from '@ecs/tng-common/components/image/Image';
import parse from 'html-react-parser';
import { sharedAssetsPath } from '@ecs/tng-common/scripts/data';
import LazyLoadedComponent from '@ecs/tng-common/components/lazy-loaded-component/LazyLoadedComponent';
import {
  DefaultCTAComponentProps,
  IConfCTAValues,
  IConfCTAValuesBottom,
  IConfCTAValuesCommon,
  ifCRMcampaignIsSet,
  ifCustomCTARestriction,
  returnCTAcomponentsData
} from '../../helpers/cta-components';

type BottomPromoBannerProps = DefaultCTAComponentProps & {
  className?: string;
};
type BottomPromoBannerState = IConfCTAValuesBottom & IConfCTAValuesCommon;

class BottomPromoBanner extends React.Component<BottomPromoBannerProps, BottomPromoBannerState> {
  defaultOp = 'BNN';

  placement = 'banr';

  ctaData: IConfCTAValues | null = ifCustomCTARestriction(this.props.ctaCustom)
    ? null
    : returnCTAcomponentsData({
        customCta: this.props.ctaCustom,
        category: this.props.category,
        articleId: this.props.articleId,
        categoryId: this.props.categoryId,
        placement: this.placement
      });

  constructor(props: BottomPromoBannerProps) {
    super(props);
    this.state = {
      btnLink: this.ctaData ? this.ctaData.btnLink : '',
      promoHeading: this.ctaData ? this.ctaData.promoHeading : '',
      promoSubHeading: this.ctaData ? this.ctaData.promoSubHeading : '',
      dataLinkAttr: this.ctaData ? this.ctaData.dataLinkAttr : '',
      promoBtnCopy: this.ctaData ? this.ctaData.promoBtnCopy : '',
      promoIcon: this.ctaData ? this.ctaData.promoIcon : '',
      promoSubBtnText: this.ctaData ? this.ctaData.promoSubBtnText : '',
      dataOp: this.ctaData ? (this.ctaData?.dataOp ?? this.defaultOp) : this.defaultOp
    };
  }

  componentDidMount() {
    if (!ifCustomCTARestriction(this.props.ctaCustom) && typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window?.location?.search);
      const pc = urlParams.get('pc');
      const ty = urlParams.get('ty');
      if (ifCRMcampaignIsSet(pc, ty)) {
        const ctaData: IConfCTAValues = returnCTAcomponentsData({
          customCta: this.props.ctaCustom,
          pc: pc,
          ty: ty,
          cc: urlParams.get('cc'),
          mkid: urlParams.get('mkid'),
          category: this.props.category,
          articleId: this.props.articleId,
          categoryId: this.props.categoryId,
          placement: this.placement
        });
        this.setState(
          {
            btnLink: ctaData.btnLink,
            promoHeading: ctaData.promoHeading,
            promoSubHeading: ctaData.promoSubHeading,
            dataLinkAttr: ctaData.dataLinkAttr,
            promoBtnCopy: ctaData.promoBtnCopy,
            promoIcon: ctaData.promoIcon,
            promoSubBtnText: ctaData.promoSubBtnText || '',
            dataOp: ctaData.dataOp ?? this.defaultOp
          },
          () => {
            if (this.state.dataOp && window.opAppend) {
              window.opAppend();
            }
          }
        );
      } else if (this.state.dataOp && window.opAppend) {
        window.opAppend();
      }
    }
  }

  render() {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {this.ctaData ? (
          <LazyLoadedComponent
            lazyLoading
            as="div"
            className={`${this.props.className || ''} border rounded d-flex align-items-start p-3 p-lg-4 justify-content-between bg-coconut bottom-promo`}>
            <div>
              <h2 className="h5">{parse(this.state.promoHeading)}</h2>
              <p className="body-text-sm text-gray">{parse(this.state.promoSubHeading)}</p>
              {this.state.btnLink ? (
                <a
                  {...(this.state.dataOp !== ''
                    ? { 'data-op': this.props.dataOp || this.defaultOp }
                    : {})}
                  href={this.state.btnLink}
                  data-link-both={this.state.dataLinkAttr}
                  className="btn btn-primary">
                  {parse(this.state.promoBtnCopy)}
                </a>
              ) : (
                <button
                  type="button"
                  {...(this.state.dataOp !== ''
                    ? { 'data-op': this.props.dataOp || this.defaultOp }
                    : {})}
                  data-link-both={this.state.dataLinkAttr}
                  className="btn btn-primary"
                  onClick={this.props.buttonCTAclick}>
                  {parse(this.state.promoBtnCopy)}
                </button>
              )}

              {this.state.promoSubBtnText ? (
                <p className="body-text-sm mt-3 fw-bold">{parse(this.state.promoSubBtnText)}</p>
              ) : null}
            </div>
            <Image
              src={`${sharedAssetsPath}/icons/${this.state.promoIcon}.svg`}
              alt="Promo icon."
              width="120"
              height="120"
              className="spot-icon-lg ms-3"
              lazyLoading
            />
          </LazyLoadedComponent>
        ) : null}
      </>
    );
  }
}

export default BottomPromoBanner;
